/** @jsxImportSource react */

export const generateSelectOptions = (options) => (
  <>
    <option value='' disabled>
      Select
    </option>
    {options.map((i) => (
      <option key={i} value={i}>
        {i}
      </option>
    ))}
  </>
);

export const generateSelectOptionsWithLabelValue = (options) => (
  <>
    <option value='' disabled>
      Select
    </option>
    {options?.map((op) => (
      <option key={op.value} value={op.value}>
        {op.label}
      </option>
    ))}
  </>
);

export const generateBoxOptions = (options) =>
  options.map((option) => ({ label: option, value: option }));
